import { useSelector } from 'react-redux'
import { useMemo } from 'react'
import { selectOrdersGridListStructure } from '@/features/domain/lists'

export function useVisibleOrderIds() {
  const { list } = useSelector(selectOrdersGridListStructure)

  return useMemo(() => list.filter(item => typeof item === 'string') as string[], [list])
}
